import { ChatMessageContent, emptyChatMessageContent } from '../ChatMessageStore/Types';
import { Error } from '../ErrorHandling';

interface Ready {
  kind: 'ready';
  reply: ChatMessageContent;
}

interface Updating {
  kind: 'updating';
  reply: ChatMessageContent;
}

interface Broadcasting {
  kind: 'broadcasting';
  reply: ChatMessageContent;
}

interface Hidden {
  kind: 'hidden';
  reply: ChatMessageContent;
}

export const hidden = (reply: ChatMessageContent): Hidden => ({
  kind: 'hidden',
  reply: reply,
});

export const reset = (): Hidden => ({
  kind: 'hidden',
  reply: emptyChatMessageContent(),
});

export const ready = (reply: ChatMessageContent): Ready => ({
  kind: 'ready',
  reply: reply,
});

export const updating = (reply: ChatMessageContent): Updating => ({
  kind: 'updating',
  reply: reply,
});

export const broadcasting = (reply: ChatMessageContent): Broadcasting => ({
  kind: 'broadcasting',
  reply: reply,
});

export type ChatReplyState = Ready | Updating | Broadcasting | Error | Hidden;
